import React, { useState } from "react";

import { updateEmail } from "services";

import { incompleteMessage, useCancelAsyncOnUnmount, useToggleNavs, useTranslation } from "utils";

import { Button, Col, Form, Input, InputPassword, MainPage, NavigationHeader, Row, Message as message } from "components";

export const UpdateEmail = () => {
  const { t } = useTranslation(["user", "meta"]);
  useToggleNavs(false, false);

  const [loading, setLoading] = useState(false);
  const signal = useCancelAsyncOnUnmount()();

  const complete = (v) => {
    setLoading(true);

    updateEmail({
      ...v,
      ...{ signal },
    }).then((res) => {
      if (res.emailExists) {
        message({ content: t("profileUpdate.emailExists"), icon: "error" });
      } else {
        if (res.success) {
          message({ content: t("profileUpdate.confirmEmail"), icon: "tick" });
        } else {
          message({ content: t("profileUpdate.changeEmailFailure"), icon: "error" });
        }
      }

      setLoading(false);
    });
  };

  return (
    <MainPage loading={loading} pageName={"profile"} containerClass="tiny">
      <NavigationHeader title={t("profileUpdate.email.headerTitle")} />
      <Form name="profile" onFinish={(v) => complete(v)} onFinishFailed={() => incompleteMessage(t("errors.mandatoryFields"))}>
        <Row>
          <Col>
            <h2>{t("profileUpdate.email.title")}</h2>
          </Col>
        </Row>
        <Row>
          <Col>
            <p style={{ maxWidth: "768px" }}>{t("profileUpdate.email.description")}</p>
          </Col>
        </Row>
        <Row>
          <Col sm={24} md={14}>
            <Input name="email" label={t("profileUpdate.email.inputs.email")} rules={[{ required: true }]} />
          </Col>
          <Col sm={24} md={10}>
            <InputPassword name="password" label={t("profileUpdate.email.inputs.password")} rules={[{ required: true }]} />
          </Col>
        </Row>
        <Row className="margin-top-300">
          <Col className="center">
            <Form.Item>
              <Button type="primary" htmlType="submit" disabled={loading} loading={loading}>
                {t("profileUpdate.email.inputs.button")}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </MainPage>
  );
};
